import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import { caretForward as expandIcon } from 'ionicons/icons';
import React from 'react';

import { useStyles } from './styles';

export interface AccordionProps {
  label: string;
  count?: number;
  expanded: boolean;
  onToggle: () => void;
  style?: React.CSSProperties;
}

const Accordion: React.FC<AccordionProps> = ({ label, count, expanded, onToggle, style }) => {
  const classes = useStyles();

  return (
    <div style={style} className={classes.wrapper}>
      <div
        className={clsx(classes.pill, expanded && classes.expanded)}
        aria-expanded={expanded}
        onClick={onToggle}
      >
        <span className={classes.iconWrapper}>
          <IonIcon
            icon={expandIcon}
            className={clsx(classes.icon, expanded && classes.iconExpanded)}
          />
        </span>
        <span className={clsx(classes.label, expanded && classes.labelExpanded)}>{label}</span>
        {count !== undefined && (
          <span className={clsx(classes.count, expanded && classes.countExpanded)}>{count}</span>
        )}
      </div>
    </div>
  );
};

export default Accordion;
